// @ts-nocheck
import React, { Component, Fragment } from "react";
import Modal from "../../../modal/modal.component";
import PubSub from "pubsub-js";
import { eventNames } from "../../../../constants/eventNames";
import { toast } from "react-toastify";
import ApiService from "../../../../services/api.service";
import { LoaderService } from "../../../../services/loader.service";

class NodeNameEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nodeData: this.props.nodeData,
      isGlobal: props.nodeData.isGlobal,
      type: null
    };
    this.apiService = ApiService.getInstance();
  }
  onChangeInput = event => {
    this.setState({ nodeData: { ...this.state.nodeData, name: event.target.value } });
  };
  onChangeAlphaNumericInput(e) {
    const value = e.target.value; //this will admit letters, numbers and dashes
    /*const regex = /^[0-9a-zA-Z(\-)]+$/;*/ const regex = /^[0-9a-zA-Z\-_]+$/;
    if (value.match(regex) || value === "") {
      this.setState({ nodeData: { ...this.state.nodeData, name: e.target.value } });
    }
  }

  save = e => {
    e.preventDefault();
    const { id, name, url } = this.state.nodeData;
    let isGlobal = this.state.isGlobal;
    let body = { name: name };
    if (this.getFileType() === "variable") {
      body["isGlobal"] = isGlobal;
    }
    LoaderService.show();
    this.apiService.put(`/${url}/${id}`, body).then(res => {
      if (res.success) {
        toast.success("Name successfully updated!");
        if (this.getFileType() === "variable") {
          // PubSub.publish(eventNames.updateTree);
        }
        PubSub.publish(eventNames.treeNodeNameUpdated, { name, isGlobal });
        PubSub.publish(eventNames.updateNodeName, { name });
        if (window.location.href.indexOf("/work-flows") >= 0) {
          PubSub.publish(eventNames.flowUpdated, res.payload);
        }
        if (window.location.href.indexOf("/apis") >= 0 || url === "api") {
          PubSub.publish(eventNames.publishAPIRec, { rec: res.payload });
        }
        this.props.close();
      } else {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.error((res.error && res.error.description) || "Something went wrong.");
        }
      }
      LoaderService.hide();
    });
  };
  getFileType = () => {
    let type = this.state.nodeData.url.substring(0, this.state.nodeData.url.length);
    type = type === "uservariables" ? "variable" : type;
    type = type === "projects" ? "project" : type;
    return type === "api" || type === "Api" ? "API" : type;
  };
  componentDidMount() {}

  render() {
    return (
      <Modal>
        <Fragment>
          <div className="modal-dialog modal-add-activity-content">
            <div className={`modal-content`}>
              <div className="modal-header">
                <h4>
                  <span className="glyphicon glyphicon-lock" />
                  Edit <span style={{ textTransform: "capitalize " }}> {this.getFileType()}</span> name
                </h4>

                <button type="button" className="close" onClick={this.props.close}>
                  &times;
                </button>
              </div>
              <div className="modal-add-activity">
                <div className="modal-body">
                  <div className="form-group">
                    <label className="required" htmlFor="ColumnName">
                      Name:
                    </label>
                    <input
                      className="form-control"
                      id="NodeFileName"
                      name="name"
                      onChange={event => this.onChangeAlphaNumericInput(event)}
                      value={this.state.nodeData.name}
                      type="text"
                      maxLength="200"
                      placeholder="Enter name please"
                    />
                  </div>
                  {this.getFileType() === "variable" && (
                    <div className="form-group">
                      <label className="form-label" htmlFor="Is Global">
                        Is Global:
                      </label>
                      <input
                        onChange={e => this.setState({ isGlobal: !this.state.isGlobal })}
                        name="isGlobal"
                        type="checkbox"
                        checked={this.state.isGlobal}
                        className="form-control"
                        value={this.state.isGlobal}
                        style={{ width: "20px", marginLeft: "20px" }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  disabled={!this.state.nodeData.name.length}
                  onClick={this.save}
                  type="submit"
                  ref={"submitBtn"}
                  className={`btn btn-success `}
                >
                  Save
                </button>
                <button onClick={this.props.close} type="button" className="btn btn-danger" data-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Fragment>
      </Modal>
    );
  }
}

export default NodeNameEditModal;
